import { BannerErrorConfigModel } from '../../../Common/Misc/models/banner-error-config.model';

export enum AlertBannerErrorTypeEnum {
    ALERT_SOURCE_ERROR = 'AlertSourceError',
    ALERT_NAME_ERROR = 'AlertNameError',
    ALERT_SUBJECT_ERROR = 'AlertSubjectError',
    ALERT_FROMNAME_ERROR = 'AlertFromnameError',
    ALERT_REPLYTO_ERROR = 'AlertReplytoError',
    ALERT_RECIPIENT_ERROR = 'AlertRecipientError',
    ALERT_SCHEDULING_ERROR = 'AlertSchedulingError',
    ALERT_RSS_FEED_ERROR = 'AlertRssFeedError',
    ALERT_INVALID_FILTER = 'AlertInvalidFilter'
}

export const bannerErrorsMap = new Map<string, BannerErrorConfigModel>([
    [AlertBannerErrorTypeEnum.ALERT_SOURCE_ERROR, {errorId: 'source_error',label: 'Alerts.input.alertSource.coverageSource'}],
    [AlertBannerErrorTypeEnum.ALERT_NAME_ERROR, {errorId: 'name_errors',label: 'Alerts.input.alertName'}],
    [AlertBannerErrorTypeEnum.ALERT_SUBJECT_ERROR, {errorId: 'subject_errors',label: 'Alerts.input.subjectLine'}],
    [AlertBannerErrorTypeEnum.ALERT_FROMNAME_ERROR, {errorId: 'fromName_errors',label: 'Alerts.input.fromName'}],
    [AlertBannerErrorTypeEnum.ALERT_REPLYTO_ERROR, {errorId: 'replyTo_errors',label: 'Alerts.input.replyTo'}],
    [AlertBannerErrorTypeEnum.ALERT_RECIPIENT_ERROR, {errorId: 'recipient_error',label: 'Alerts.input.recipients'}],
    [AlertBannerErrorTypeEnum.ALERT_SCHEDULING_ERROR, {errorId: 'scheduling_errors',label: 'Alerts.sidebar.headingScheduling'}],
    [AlertBannerErrorTypeEnum.ALERT_RSS_FEED_ERROR, {errorId: 'rss_feed_errors', label: 'Briefings.deliveryOptions.rssFeed'}],
    [AlertBannerErrorTypeEnum.ALERT_INVALID_FILTER, {errorId: 'invalid_filter', label: 'Alerts.error.invalidFilter'}]

]);

